module.exports = __webpack_public_path__ + "static/img/Lxtgsjfw.8abc74a1.png";